import { useContext } from "react";
import { AuthContext } from "../../../context/authContext";
import { useTranslation } from "react-i18next";
import ActionLinkButton from "../../atoms/buttons/ActionLinkButton";

const SignOutButton = () => {
  const { t } = useTranslation();
  const { signOut } = useContext(AuthContext);

  return <ActionLinkButton text={t("home.logout")} handleClick={signOut} />;
};

export default SignOutButton;
